import { render, staticRenderFns } from "./AigcProviderConfigPage.vue?vue&type=template&id=7942fc32&scoped=true&"
import script from "./AigcProviderConfigPage.vue?vue&type=script&lang=js&"
export * from "./AigcProviderConfigPage.vue?vue&type=script&lang=js&"
import style0 from "./AigcProviderConfigPage.vue?vue&type=style&index=0&id=7942fc32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7942fc32",
  null
  
)

export default component.exports